module.exports = __webpack_public_path__ + "img/hive.490f5911.svg";